import { render, staticRenderFns } from "./mobileVerification.vue?vue&type=template&id=170dc2a6&scoped=true&"
import script from "./mobileVerification.vue?vue&type=script&lang=js&"
export * from "./mobileVerification.vue?vue&type=script&lang=js&"
import style0 from "./mobileVerification.vue?vue&type=style&index=0&id=170dc2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170dc2a6",
  null
  
)

component.options.__file = "mobileVerification.vue"
export default component.exports